import { IAppliedOffer } from '@fhs-legacy/frontend/src/generated/graphql-gateway';
import { IMenuOptionsContext } from '@fhs-legacy/frontend/src/state/menu-options';
import { IPriceItemOptionModifierInput } from '@fhs-legacy/frontend/src/state/menu-options/hooks/use-pricing-function';
import { CartEntryType } from '@fhs-legacy/frontend/src/utils/cart';
import { ICartEntry } from '@rbi-ctg/menu';

export function repriceCartEntriesHelper(
  entries: ICartEntry[],
  pricingFunction: IMenuOptionsContext['pricingFunction'],
  priceForItemOptionModifier: (obj: IPriceItemOptionModifierInput) => number,
  priceForItemInComboSlotSelection: IMenuOptionsContext['priceForItemInComboSlotSelection'],
  appliedOffers: IAppliedOffer[],
  parentEntry?: any,
  mainCombo?: any
  // TODO: type
) {
  return entries.map(entry => {
    /***
     * This is a hack to stop using FE reprice logic
     * on menu v2 since this data is already validated from the BE for menu v2
     * We should remove this once we have a stable system
     * for price and availability
     * Context: https://rbictg.atlassian.net/browse/FHS-4603
     */
    if (entry.url?.includes('/v2/')) {
      return entry;
    }
    const hasPrice = entry.price !== undefined;
    const isItem = entry.type === CartEntryType.item;
    const isCombo = entry.type === CartEntryType.combo;
    const isSwap = appliedOffers.some(offer =>
      entry?.children.length ? offer.cartId === entry.cartId : offer?.swap?.cartId === entry.cartId
    );
    const isComboSlot = parentEntry?.type === CartEntryType.comboSlot;

    if (isItem) {
      // reprices an item and its grandchild itemOptionModifiers in one go.
      const priceFunc = isComboSlot
        ? priceForItemInComboSlotSelection({
            combo: mainCombo,
            comboSlot: parentEntry,
            selectedItem: entry as any,
          })
        : pricingFunction(entry, entry.quantity);
      return {
        ...entry,
        // prices are not defined on main items in combos, we need to preserve this
        ...(!isSwap && hasPrice && { price: priceFunc }),
        children: (entry.children || []).map((itemOption: any) => ({
          ...itemOption,
          children: (itemOption.children || []).map(modifier => ({
            ...modifier,
            price: priceForItemOptionModifier({ item: entry, itemOption, modifier }),
          })),
        })),
      };
    }

    return {
      ...entry,
      ...(!isSwap && isCombo && hasPrice && { price: pricingFunction(entry, entry.quantity) }),
      children: repriceCartEntriesHelper(
        entry.children,
        pricingFunction,
        priceForItemOptionModifier,
        priceForItemInComboSlotSelection,
        appliedOffers,
        entry,
        isCombo ? entry : mainCombo
      ),
    };
  });
}
